// React
import React, { useEffect } from 'react';

// Packages

// Utilities
import { useElseware, useLabels, useContext } from 'utilities/hooks';
import { useInitiativeDataStore } from 'utilities/store';
import { CONSTANTS } from 'utilities/configuration';

// Components
import { InputWrapper, FormFields } from 'components/_inputs';

const ResultReflections = ({ initComponent, form }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();
    const { REPORT_ID } = useContext();

    // ///////////////////
    // STATE
    // ///////////////////

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { ewCreate, ewUpdate } = useElseware();
    const { object, label } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    async function addItem(formData) {
        try {
            // Get saved data
            const { Reflection___Description__c, Result___Id } = formData;

            const { data: itemData } = await ewCreate(
                'initiative-report-detail/initiative-report-detail',
                {
                    Description__c: Reflection___Description__c,
                    Initiative_Result__c: Result___Id,
                    Type__c: CONSTANTS.REPORT_DETAILS.RESULTS,
                    Initiative_Report__c: REPORT_ID,
                }
            );

            // Update main data
            utilities.updateInitiativeData('_reportDetails', itemData);
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    async function editItem(formData) {
        try {
            // Get saved data
            const { Reflection___Description__c, Reflection___Id } = formData;

            if (Reflection___Id) {
                const { data: itemData } = await ewUpdate(
                    'initiative-report-detail/initiative-report-detail',
                    Reflection___Id,
                    {
                        Description__c: Reflection___Description__c,
                    }
                );
                // Update main data
                utilities.updateInitiativeData('_reportDetails', itemData);
            } else {
                await addItem(formData);
            }
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    // ///////////////////
    // EFFECTS
    // ///////////////////

    useEffect(() => {
        initComponent({
            fields: fields(),
            methods: {
                add: { reflections: addItem },
                edit: { reflections: editItem },
            },
        });
    }, []);

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Reflection',
                name: 'Reflection___Description__c',
                object: {
                    ...object.config(
                        'Initiative_Report_Detail__c.Description__c'
                    ),
                    required: true,
                },
                maxLength: 750,
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return (
        <div className="flex flex-col space-y-24">
            {/* Fields */}
            <h4 className="text-blue-100 t-h5">
                {label('ResultBuilderReflections_Reflections_Label')}
            </h4>
            <div className="p-16 bg-blue-10 rounded-8">
                <InputWrapper>
                    <FormFields
                        {...{
                            fields: fields(),
                            form,
                            theme: 'blue',
                        }}
                    />
                </InputWrapper>
            </div>
        </div>
    );
};

export default ResultReflections;
